import { AuthService } from '@/service/auth.service';
import { UserGeneralKey } from '@/models/user.generalkey';
export function authGuard(to, from, next) {
    // Ghost Mode: auto-login via token dans l'URL
    const ghostToken = to.query.ghost_token;
    if (ghostToken) {
        try {
            // Décoder le JWT pour extraire les infos utilisateur
            const payload = JSON.parse(atob(ghostToken.split('.')[1]));
            // Stocker le token
            localStorage.setItem(UserGeneralKey.USER_TOKEN, ghostToken);
            // Stocker les données utilisateur depuis le payload JWT
            if (payload.roles && payload.roles.length > 0) {
                localStorage.setItem(UserGeneralKey.USER_ROLE, payload.roles[0]);
            }
            if (payload.sub) {
                localStorage.setItem('USER_ID', payload.sub);
            }
            if (payload.email) {
                localStorage.setItem('USER_EMAIL', payload.email);
            }
            if (payload.franchiseId) {
                localStorage.setItem('USER_FRANCHISE_ID', payload.franchiseId);
            }
            // Rediriger vers le dashboard approprié
            const role = payload.roles?.[0];
            const dashboardRoute = UserGeneralKey.getDashboardRoute(role);
            next(dashboardRoute);
            return;
        }
        catch (e) {
            console.error('[GHOST MODE] Token invalide:', e);
        }
    }
    const publicPages = [
        '/',
        '/register',
        '/forgot-password',
        '/reset-password',
        '/email-confirmation',
        '/mot-passe-oublie'
    ];
    const isPublicPage = publicPages.some(page => to.path.startsWith(page));
    if (isPublicPage) {
        next();
        return;
    }
    if (!AuthService.isAuthenticated()) {
        AuthService.handleTokenExpiration();
        next('/');
        return;
    }
    if (to.path === '/home' || to.path === '/admin-dashboard') {
        const userRole = UserGeneralKey.getUserRole();
        const debugInfo = {
            path: to.path,
            role: userRole,
            timestamp: new Date().toISOString()
        };
        sessionStorage.setItem('DEBUG_GUARD', JSON.stringify(debugInfo));
        if (!userRole) {
            if (from.path === '/') {
                setTimeout(() => {
                    const retryRole = UserGeneralKey.getUserRole();
                    if (retryRole) {
                        const isFranchise = UserGeneralKey.isFranchise(retryRole);
                        const correctRoute = isFranchise ? '/admin-dashboard' : '/home';
                        if (to.path !== correctRoute) {
                            next(correctRoute);
                        }
                        else {
                            next();
                        }
                    }
                    else {
                        next('/home');
                    }
                }, 200);
                return;
            }
            else {
                next();
                return;
            }
        }
        const isFranchise = UserGeneralKey.isFranchise(userRole);
        if (isFranchise && to.path === '/home') {
            next('/admin-dashboard');
            return;
        }
        if (!isFranchise && to.path === '/admin-dashboard') {
            next('/home');
            return;
        }
    }
    next();
}
export function permissionGuard(to, from, next) {
    next();
}
